import React, {Component} from 'react'
import theme from '../../theme'
import PropTypes from 'prop-types'

// application component
import Typography from '@mui/material/Typography';
import SidebarItem from "../Sidebar/SidebarItem/SidebarItem";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import {Trans} from'react-i18next'
import {t} from 'i18next'
class AccountPasswordChange extends Component {

    constructor(props) {
        super(props);

        this.state = {
            inputs: {
                currentPw: '',
                newPw: '',
                repeatNewPw: ''
            },
            repeatPwError: '',
            errorMsg: ''
        }
    }

    handleChangeInput = (key, value) => {
        const { inputs } = this.state;
        inputs[key] = value;
        this.setState({inputs, errorMsg: ''});

        if(key === 'repeatNewPw') {
            if(inputs.newPw !== value) {
                this.setState({repeatPwError: t('PasswordNew.error_text_repeat_password')});
            } else {
                this.setState({repeatPwError: ''})
            }
        }
    };

    onSubmitChange = () => {
        const { inputs: {currentPw, newPw}} = this.state;

        this.props.onChangeRequest(currentPw, newPw,
            () => {
                this.props.onSuccess();
            },
            (error) => {
                if(error.msg) {
                    this.setState({errorMsg: error.msg})
                }
            })
    };

    render() {
        const { classes } = this.props;
        const { inputs: {currentPw, newPw, repeatNewPw}, repeatPwError, errorMsg } = this.state;

        const inputsValid = currentPw.trim().length > 0 && newPw.trim().length > 0 && repeatNewPw.trim().length > 0 && newPw === repeatNewPw;

        return (
            <SidebarItem>
                <Typography style={{...styles.resetText, marginTop:-40, marginBottom:20}} color={'error'}>
                    <Trans i18nKey="User.siebartext_change_password"/>
                </Typography>
                <div style={styles.inputContainer}>
                    <TextField
                        InputLabelProps={{
                            FormLabelClasses: {
                                root: styles.textFieldFormLabel,
                                focused: styles.textFieldFocused,
                            },
                        }}
                        label={t('User.label_actual_password')}
                        name="currentPw"
                        value={currentPw}
                        margin="normal"
                        type="password"
                        variant={'standard'}
                        style={{...styles.textField, width:"100%"}}
                        required
                        inputProps={{
                            classes: {
                                underline: styles.textFieldUnerline
                            },
                            readOnly: Boolean(this.state.repeatPassword),
                        }}
                        error={this.state.emailError}
                        onChange={ e => this.handleChangeInput(e.target.name, e.target.value) }
                        onKeyUp={ this.handleSubmitEnter }
                    />
                    <TextField
                     InputProps={{
                            classes: {
                                underline: styles.textFieldUnerline
                            },
                        }}
                        InputLabelProps={{
                            FormLabelClasses: {
                                root: styles.textFieldFormLabel,
                                focused: styles.textFieldFocused,
                            },
                        }}
                        label={t('User.label_choose_new_password')}
                        name={'newPw'}
                        type="password"
                        value={newPw}
                        margin="normal"
                        variant={'standard'}
                        style={{...styles.textField, width: '100%'}}
                        required
                        error={repeatPwError.length > 0}
                        helperText={repeatPwError.length > 0 ? repeatPwError : ''}
                        onChange={ e => this.handleChangeInput(e.target.name, e.target.value) }
                        onKeyUp={ this.handleSubmitEnter }
                    />
                    <TextField
                     InputProps={{
                            classes: {
                                underline: styles.textFieldUnerline
                            },
                        }}
                        InputLabelProps={{
                            FormLabelClasses: {
                                root: styles.textFieldFormLabel,
                                focused: styles.textFieldFocused,
                            },
                        }}
                        label={t('User.label_confirm_new_password')}
                        name={'repeatNewPw'}
                        type="password"
                        value={repeatNewPw}
                        margin="normal"
                        variant={'standard'}
                        style={{...styles.textField, width: '100%'}}
                        required
                        error={repeatPwError.length > 0}
                        helperText={repeatPwError.length > 0 ? repeatPwError : ''}
                        onChange={ e => this.handleChangeInput(e.target.name, e.target.value) }
                        onKeyUp={ this.handleSubmitEnter }
                    />
                    {errorMsg.length > 0
                        ?  <Typography style={styles.userDelete} color='error'>{errorMsg}</Typography>
                        : null
                    }
                    <Button variant="outlined"
                            disabled={!inputsValid}
                            style={{...styles.sendButton, color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark, marginTop: 20 }}
                            onClick={this.onSubmitChange}
                            // color="primary"
                            >
                                <Trans i18nKey="User.button_change_password"/>
                            </Button>
                </div>
            </SidebarItem>
        )
    }
}

const styles = {
    textStyle: {
        fontWeight: 600,
        lineHeight: 2,
        color: theme.palette.secondary.main,
    },
    inputContainer: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        display: 'flex',
        flex: 1
    },
    textFieldFormLabel: {
        '&$textFieldFocused': {
            color: theme.palette.primary.dark,
        },
    },
    textFieldFocused: {},
    textFieldUnerline: {
        '&:after': {
            borderBottomColor: theme.palette.primary.dark,
        },
    },
};

AccountPasswordChange.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    onChangeRequest: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
};

export default AccountPasswordChange
